export const statuses = {
  UNLOADED: 'unloaded',
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error',
  AUTHENTICATION_ERROR: 'authentication-error'
}
